




























import {Vue, Component, Watch} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import TemplateSetting from '@/components/manage/inquiry/TemplateSetting.vue';
import {InquiryAnswerTemplate, GetInquiryAnswerTemplatesRequest, Mall} from 'supporter';
const mallModule = namespace('mall');
@Component({
  components: {PageTitle, MallsTab, TemplateSetting}
})
export default class InquiryTemplate extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNoVal: number = 0;
  private templates: InquiryAnswerTemplate[] = [];
  private mallNo: number = 0;
  private async getInquiryTemplates(callback?: any) {
    const templateRequest: GetInquiryAnswerTemplatesRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    const result = await this.$api.getInquiryAnswerTemplates(templateRequest);
    this.templates = result.data;
    if (callback) {
      callback(this.templates);
    }
  }

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onRouteChanged() {
    this.templates = [];
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
      await this.getInquiryTemplates();
  }

  private async mounted() {

    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      await this.fetchMalls();
      this.mallNo = this.malls[0].mallNo;
    }
    this.getInquiryTemplates();
  }
}
